import React, { useState, useEffect } from 'react';
import { useApi } from '../../api';
import {
  Paper, Typography, TextField, Button, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, IconButton,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
  Box, Divider, FormControlLabel, Checkbox, Card, useMediaQuery, useTheme,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BuildIcon from '@mui/icons-material/Build';
import dayjs from 'dayjs';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { formatearPrecio } from '../utils';
import { CircularProgress } from '@mui/material';

const ReparacionesOrden = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const from = new URLSearchParams(location.search).get('from');
  const [tecnicos, setTecnicos] = useState([]);
  const [reparaciones, setReparaciones] = useState([]);
  const [nueva, setNueva] = useState({ descripcion: '', costo: '', tecnico: '', fecha: dayjs().format('YYYY-MM-DD'), garantia: false });
  const [openDialog, setOpenDialog] = useState(false);
  const [reparacionAEliminar, setReparacionAEliminar] = useState(null);
  const [estadoOrden, setEstadoOrden] = useState('pendiente');
  const token = localStorage.getItem('token');
  const [openInventario, setOpenInventario] = useState(false);
  const [inventario, setInventario] = useState([]);
  const [repuestoSeleccionado, setRepuestoSeleccionado] = useState(null);
  const [confirmarDialog, setConfirmarDialog] = useState(false);
  const [guardandoRepuesto, setGuardandoRepuesto] = useState(false);
  const api = useApi();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));




  const fetchReparaciones = async () => {
    try {
      const response = await api.get(`${process.env.REACT_APP_API_URL}/api/reparaciones/?orden=${id}`);
      setReparaciones(response.data);
    } catch (error) {
      console.error('Error al cargar reparaciones', error);
    }
  };
  const fetchTecnicos = async () => {
  try {
    const response = await api.get(`${process.env.REACT_APP_API_URL}/api/tecnicos/`, );
    setTecnicos(response.data);
  } catch (error) {
    console.error('Error al cargar técnicos', error);
  }
};

const agregarRepuestoDesdeInventario = async (item) => {
  try {
    const payload = {
      descripcion: `Repuesto: ${item.nombre} - ${item.descripcion}`,
      costo: item.precio_cliente || 0,
      fecha: dayjs().format('YYYY-MM-DD'),
      orden: id,
      tecnico_id: 1  // Técnico fijo "Taller Anduze"
    };

    // Crear reparación
    await api.post(`${process.env.REACT_APP_API_URL}/api/reparaciones/`, payload);

    // Actualizar estado de orden a "en_proceso"
    await api.patch(`${process.env.REACT_APP_API_URL}/api/ordenes/${id}/`, { estado: 'en_proceso' });
    setEstadoOrden('en_proceso');

    // Descontar del inventario
    await api.patch(`${process.env.REACT_APP_API_URL}/api/inventario/productos/${item.id}/`, {
      cantidad: item.cantidad - 1
    });

    
    fetchInventario();
   
  } catch (error) {
    console.error('Error al agregar repuesto como reparación', error);
  }
};


const fetchInventario = async () => {
  try {
    const response = await api.get(`${process.env.REACT_APP_API_URL}/api/inventario/productos/`);
    console.log('Inventario recibido:', response.data); // Verificación visual
    setInventario(response.data);  // <- ESTO ESTÁ BIEN ya que es un array
  } catch (error) {
    console.error('Error al cargar inventario', error);
  }
};


  const fetchEstadoOrden = async () => {
    try {
      const response = await api.get(`${process.env.REACT_APP_API_URL}/api/ordenes/${id}/`);
      setEstadoOrden(response.data.estado);
    } catch (error) {
      console.error('Error al obtener estado de orden', error);
    }
  };

  useEffect(() => {
    fetchReparaciones();
    fetchEstadoOrden();
    fetchTecnicos();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNueva(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const agregarReparacion = async () => {
    try {
          const payload = {
            descripcion: nueva.descripcion,
            costo: nueva.costo,
            fecha: nueva.fecha,
            orden: id,
            tecnico_id: nueva.tecnico,
            garantia: nueva.garantia
          };
      await api.post(`${process.env.REACT_APP_API_URL}/api/reparaciones/`, payload);
      setNueva({ descripcion: '', costo: '', tecnico: '', fecha: dayjs().format('YYYY-MM-DD'), garantia: false });
      fetchReparaciones();

      await api.patch(`${process.env.REACT_APP_API_URL}/api/ordenes/${id}/`, { estado: 'en_proceso' });
      setEstadoOrden('en_proceso');
    } catch (error) {
      console.error('Error al agregar reparación', error);
    }
  };

  const confirmarEliminacion = (reparacionId) => {
    setReparacionAEliminar(reparacionId);
    setOpenDialog(true);
  };

  const cancelarEliminacion = () => {
    setOpenDialog(false);
    setReparacionAEliminar(null);
  };

  const eliminarReparacion = async () => {
    try {
      await api.delete(`${process.env.REACT_APP_API_URL}/api/reparaciones/${reparacionAEliminar}/`);
      setOpenDialog(false);
      setReparacionAEliminar(null);
      fetchReparaciones();
    } catch (error) {
      console.error('Error al eliminar reparación', error);
    }
  };

  const marcarCompletada = async () => {
    try {
      if (reparaciones.length === 0) {
        alert('No se puede marcar como completada una orden sin reparaciones registradas.');
        return;
      }
      await api.patch(`${process.env.REACT_APP_API_URL}/api/ordenes/${id}/`, { estado: 'completado' });
      setEstadoOrden('completado');
      alert('Orden marcada como completada');
      navigate('/facturas');
    } catch (error) {
      console.error('Error al marcar como completada', error);
    }
  };

  const calcularTotal = () => {
    return reparaciones.reduce((acc, r) => acc + parseFloat(r.costo), 0).toFixed(2);
  };

  return (
    <Paper sx={{ padding: 3 }} className="card-app">
      <Typography variant="h6" gutterBottom className="titulo-app sin-subrayado" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <BuildIcon sx={{ color: '#083a94' }} /> Reparaciones para Orden #{id}
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'flex-start', mb: 3 }}>
        <TextField
          label="Descripción"
          name="descripcion"
          value={nueva.descripcion}
          onChange={handleInputChange}
          fullWidth
          multiline
          rows={2}
        />
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center', width: '100%' }}>
          <TextField
            label="Costo"
            name="costo"
            type="number"
            value={nueva.costo}
            onChange={handleInputChange}
          />
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id="tecnico-label">Técnico Asignado</InputLabel>
            <Select
              labelId="tecnico-label"
              name="tecnico"
              value={nueva.tecnico}
              onChange={handleInputChange}
              label="Técnico Asignado"
            >
              {tecnicos.map((tec) => (
                <MenuItem key={tec.id} value={tec.id}>
                  {tec.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Fecha"
            name="fecha"
            type="date"
            value={nueva.fecha}
            onChange={handleInputChange}
            InputLabelProps={{ shrink: true }}
          />

          <FormControlLabel
            control={
              <Checkbox
                name="garantia"
                checked={nueva.garantia}
                onChange={handleInputChange}
              />
            }
            label="Garantía"
          />

          <Box sx={{ flexGrow: 1 }} />

          <Button
            variant="outlined"
            color="secondary"
            startIcon={<Inventory2Icon />}
            onClick={() => {
              setOpenInventario(true);
              fetchInventario();
            }}
          >
            Agregar Repuesto
          </Button>
          <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={agregarReparacion}>
            Agregar
          </Button>
        </Box>
      </Box>

      {isMobile ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {reparaciones.map((r) => (
            <Card key={r.id} variant="outlined" sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Typography sx={{ fontWeight: 700 }}>
                  #{r.id} · {r.garantia ? `[Garantía] ${r.descripcion}` : r.descripcion}
                </Typography>
                <IconButton color="error" onClick={() => confirmarEliminacion(r.id)} sx={{ ml: 1 }}>
                  <DeleteIcon />
                </IconButton>
              </Box>
              <Typography variant="body2" color="text.secondary">Técnico: {r.tecnico?.nombre || '—'}</Typography>
              <Typography variant="body2" color="text.secondary">{r.fecha}</Typography>
              <Typography sx={{ fontWeight: 600, mt: 0.5 }}>${formatearPrecio(r.costo)}</Typography>
            </Card>
          ))}
        </Box>
      ) : (
      <TableContainer sx={{ overflowX: 'auto' }}>
        <Table className="tabla-app">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Costo</TableCell>
              <TableCell>Técnico</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reparaciones.map((r) => (
              <TableRow key={r.id}>
                <TableCell>{r.id}</TableCell>
                <TableCell>{r.garantia ? `[Garantía] ${r.descripcion}` : r.descripcion}</TableCell>
                <TableCell>${formatearPrecio(r.costo)}</TableCell>
                <TableCell>{r.tecnico?.nombre}</TableCell>
                <TableCell>{r.fecha}</TableCell>
                <TableCell>
                  <IconButton color="error" onClick={() => confirmarEliminacion(r.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      )}

      <Typography variant="subtitle1" align="right" sx={{ mt: 2, fontWeight: 700, color: '#083a94' }}>
        Total reparaciones: ${formatearPrecio(calcularTotal())}
      </Typography>

      <Divider sx={{ my: 2 }} />

      <div className="text-end">
        <Button
          variant="text"
          color="inherit"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(from === 'facturas' ? '/facturas' : '/ordenes')}
          sx={{ mr: 2, color: '#616161' }}
        >
          Volver
        </Button>
        {estadoOrden !== 'completado' && (
          <Button variant="contained" color="success" startIcon={<CheckCircleIcon />} onClick={marcarCompletada}>
            Marcar como Completada
          </Button>
        )}
      </div>

      <Dialog open={openDialog} onClose={cancelarEliminacion}>
        <DialogTitle>Confirmar Eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Estás seguro de que deseas eliminar esta reparación? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelarEliminacion}>Cancelar</Button>
          <Button onClick={eliminarReparacion} color="error" variant="contained">Eliminar</Button>
        </DialogActions>
                </Dialog>
                <Dialog open={openInventario} onClose={() => setOpenInventario(false)} maxWidth="md" fullWidth>
            <DialogTitle>Seleccionar Repuesto del Inventario</DialogTitle>
            <DialogContent>
              {isMobile ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {inventario.map((item) => (
                    <Card key={item.id} variant="outlined" sx={{ p: 2 }}>
                      <Typography sx={{ fontWeight: 700 }}>{item.nombre}</Typography>
                      <Typography variant="body2" color="text.secondary">{item.descripcion}</Typography>
                      <Typography variant="body2" color="text.secondary">Disponibles: {item.cantidad}</Typography>
                      <Typography sx={{ fontWeight: 600, mt: 0.5, mb: 1.5 }}>
                        ${formatearPrecio(parseFloat(item.precio_cliente))}
                      </Typography>
                      <Button
                        variant="contained"
                        size="small"
                        disabled={item.cantidad <= 0}
                        onClick={() => {
                          setRepuestoSeleccionado(item);
                          setConfirmarDialog(true);
                        }}
                      >
                        Agregar
                      </Button>
                    </Card>
                  ))}
                </Box>
              ) : (
              <TableContainer sx={{ overflowX: 'auto' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Descripción</TableCell>
                    <TableCell>Disponibles</TableCell>
                    <TableCell>Precio</TableCell>
                    <TableCell>Acción</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {inventario.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.nombre}</TableCell>
                      <TableCell>{item.descripcion}</TableCell>
                      <TableCell>{item.cantidad}</TableCell>
                      <TableCell>${formatearPrecio(parseFloat(item.precio_cliente))}</TableCell>
                      <TableCell>
                          <Button
                            variant="contained"
                            size="small"
                            disabled={item.cantidad <= 0}
                            onClick={() => {
                              setRepuestoSeleccionado(item);
                              setConfirmarDialog(true);
                            }}
                          >
                            Agregar
                          </Button>

                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              </TableContainer>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenInventario(false)}>Cerrar</Button>
            </DialogActions>
          </Dialog>
          <Dialog open={confirmarDialog} onClose={() => setConfirmarDialog(false)}>
            <DialogTitle>Confirmar Agregado de Repuesto</DialogTitle>
            <DialogContent>
              <DialogContentText>
                ¿Deseas agregar el siguiente repuesto a la orden?
              </DialogContentText>
              {repuestoSeleccionado && (
                <div style={{ marginTop: '1rem' }}>
                  <Typography><strong>Nombre:</strong> {repuestoSeleccionado.nombre}</Typography>
                  <Typography><strong>Descripción:</strong> {repuestoSeleccionado.descripcion}</Typography>
                  <Typography><strong>Precio:</strong> ${formatearPrecio(repuestoSeleccionado.precio_cliente)}</Typography>
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setConfirmarDialog(false)}>Cancelar</Button>
              <Button
                variant="contained"
                color="primary"
                disabled={guardandoRepuesto}
                onClick={async () => {
                  setGuardandoRepuesto(true);
                  await agregarRepuestoDesdeInventario(repuestoSeleccionado);
                  setConfirmarDialog(false);
                  setOpenInventario(false);
                  await fetchReparaciones();
                  setGuardandoRepuesto(false);
                }}
              >
                {guardandoRepuesto ? (
                  <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <CircularProgress size={20} color="inherit" />
                    Guardando...
                  </span>
                ) : (
                  'Confirmar'
                )}
              </Button>


            </DialogActions>
          </Dialog>

    </Paper>
  );
};

export default ReparacionesOrden;
